// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__2x0El","logo":"navbar_logo__3SD_A"};